import { differenceInCalendarWeeks, isAfter } from 'date-fns';
import { HealthForceGoSkill } from './HealthForceGoAPI';

export enum ExpiryStatus {
  EXPIRED = 'expired',
  EXPIRING_SOON = 'expiring-soon',
  EXPIRING = 'expiring',
  INCOMPLETE = 'incomplete',
  NOT_EXPIRABLE = 'not-expirable',
}

const calculateExpiryStatus = (
  skills: HealthForceGoSkill[] | null
): ExpiryStatus => {
  if (!skills || !skills.length) return ExpiryStatus.NOT_EXPIRABLE;
  const skill = skills[0];
  if (!skill.hasSkill || !skill.expiryDate) return ExpiryStatus.INCOMPLETE;
  const expiryDate = new Date(skill.expiryDate);
  if (!expiryDate) return ExpiryStatus.INCOMPLETE;
  const now = new Date();
  if (isAfter(now, expiryDate)) return ExpiryStatus.EXPIRED;
  if (differenceInCalendarWeeks(expiryDate, now) <= 6)
    return ExpiryStatus.EXPIRING_SOON;
  return ExpiryStatus.EXPIRING;
};

export default calculateExpiryStatus;
